import fetch from "./sessionFetch";
import { isFinalizedAttendance } from "../../LambdaFunctions/shared/lessonAttendance";
import { calculateDatesBetween, formatDate, getStudentsInThisClass } from "../components/common/Helpers";
import {authHeaders, baseUrl, handleResponse} from "./apiUtils";

async function getSchoolClass(id) {
  const response = await fetch(`${baseUrl}classes/${id}`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function getSchoolClasses(fromDate, toDate) {
  const params = new URLSearchParams();

  if (fromDate) {
    params.append("fromDate", fromDate);
  }

  if (toDate) {
    params.append("toDate", toDate);
  }

  const query = params.toString() ? `?${params.toString()}` : "";
  const response = await fetch(`${baseUrl}classes${query}`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function saveSchoolClass(schoolClass) {
  const response = await fetch(`${baseUrl}classes/${schoolClass.id || ""}`, {
    method: schoolClass.id ? "PUT" : "POST", // POST for create, PUT to update when id already exists.
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify(schoolClass),
  });
  return handleResponse(response);
}


async function getClassStudents(fromDate, toDate) {
  const params = new URLSearchParams();

  if (fromDate) {
    params.append("fromDate", fromDate);
  }

  if (toDate) {
    params.append("toDate", toDate);
  }

  const query = params.toString() ? `?${params.toString()}` : "";
  const response = await fetch(`${baseUrl}classstudents${query}`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function saveClassStudent(classStudent) {
  const response = await fetch(`${baseUrl}classstudents`, {
    method: "POST",
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify(classStudent),
  });
  return handleResponse(response);
}

async function deleteClassStudent(classStudent) {
  // Use 'id' as primary key for json-server, not 'nid'
  const id = classStudent.id || classStudent.nid;
  const response = await fetch(`${baseUrl}classstudents/${id}`, {
    method: "DELETE",
    headers: authHeaders({ "content-type": "application/json" }),
  });
  return handleResponse(response);
}


const createLessonObject = (
  id,
  index,
  date,
  startTime,
  teacherId,
  dayOfWeek,
  classTypeId,
  isRecurring,
  students,
  classStudents,
) => ({
  id: `${id}-${index}`,
  defaultLessonDetails: {
    date: date instanceof Date ? formatDate(date) : date,
    dayOfWeek,
    startTime,
    teacherId,
    classTypeId,
    isRecurring,
    comment: "",
  },
  defaultStudents: getStudentsInThisClass(students, classStudents, id),
});

const findLessonRegister = (lessonRegister, lessonId) => lessonRegister.find(lr => lr.lessonId === lessonId) || null;

function generateScheduledClasses(
  schoolClass,
  lessonRegister,
  students,
  classStudents,
) {
  const {
    id,
    startTime,
    teacherId,
    dayOfWeek,
    isRecurring,
    fromDate,
    tillDate,
    classTypeId,
  } = schoolClass;

  if (!dayOfWeek || !fromDate) {
    return [];
  }

  const dates = isRecurring && tillDate
    ? calculateDatesBetween(fromDate, tillDate, dayOfWeek)
    : [fromDate];

  return dates.map((date, index) => {
    const lesson = createLessonObject(
      id,
      index,
      date,
      startTime,
      teacherId,
      dayOfWeek,
      classTypeId,
      isRecurring,
      students,
      classStudents,
    );

    const lessonRegisterForLesson = findLessonRegister(lessonRegister, lesson.id);
    return {
      ...lesson,
      lessonRegister: lessonRegisterForLesson,
      ...(isFinalizedAttendance(lessonRegisterForLesson) ? {
        defaultStudents: lessonRegisterForLesson.students.map(participant => (
          students.find(student => student.id === participant.id) || participant
        )),
      } : {}),
    };
  });
}


export default {
  getSchoolClass,
  getSchoolClasses,
  saveSchoolClass,
  getClassStudents,
  saveClassStudent,
  deleteClassStudent,
  generateScheduledClasses,
};
